import { FormsSparkasseAssignmentForm } from './forms/sparkasse-assignment-form';
import { InternLink } from './intern/link';
import { Page } from './page';

/**
 * Model definition for quick-navi
 */
export interface QuickNavi {
  __contentType: 'quick-navi';
  id: string;
  name?: string;
  pages?: Page[];
  items?: InternLink[];
  showCTAButton?: boolean;
  sparkassenAssignmentForm?: FormsSparkasseAssignmentForm;
}

export function isQuickNavi(obj: { __contentType?: string }): obj is QuickNavi {
  return obj.__contentType === 'quick-navi';
}
